import { Flex, Text } from '@chakra-ui/react'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { reportingApi } from '~/apis/reportingApi'
import { useDateRangeWithSearchParams } from '~/types/Shared'

import {
  ExtensionComparisonDashboard,
  type ExtensionComparisonDashboardHandle,
  ExtensionComparisonFilters,
  type ExtensionNameMap,
  ReportingI18nProvider,
} from '@mangovoice/reporting-ui'
import type { ExtensionComparisonDirection } from '@mangovoice/types'

import { useDashboardContext } from './context/DashboardContext'

export const ExtensionComparisonPage = () => {
  const { t, i18n } = useTranslation()
  const { pbxId, timeZone } = useDashboardContext()
  const [dateRange, setDateRange] = useDateRangeWithSearchParams()
  const [canExport, setCanExport] = useState(false)
  const [direction, setDirection] =
    useState<ExtensionComparisonDirection>('all')
  const [selectedExtensions, setSelectedExtensions] = useState<string[]>([])
  const [availableExtensions, setAvailableExtensions] = useState<string[]>([])
  const [extensionNameMap, setExtensionNameMap] = useState<ExtensionNameMap>(
    new Map(),
  )
  const dashboardRef = useRef<ExtensionComparisonDashboardHandle>(null)

  return (
    <ReportingI18nProvider t={t} locale={i18n.language}>
      <Flex
        padding="1.25rem"
        flexDirection="column"
        alignItems="center"
        gap="0.25rem"
        flex="1 0 0"
        alignSelf="stretch"
        overflow="auto"
      >
        <ExtensionComparisonFilters
          dateTimeRange={dateRange}
          onValueChange={setDateRange}
          direction={direction}
          onDirectionChange={setDirection}
          selectedExtensions={selectedExtensions}
          extensions={availableExtensions}
          extensionNameMap={extensionNameMap}
          isExtensionsLoading={false}
          onExtensionChange={setSelectedExtensions}
          onExportCsv={() => dashboardRef.current?.exportCsv()}
          isExportCsvDisabled={!canExport || !dateRange}
        />
        {dateRange ? (
          <ExtensionComparisonDashboard
            ref={dashboardRef}
            api={reportingApi}
            t={t}
            locale={i18n.language}
            sharedDateRange={dateRange}
            selectedPbxId={pbxId}
            timeZone={timeZone}
            direction={direction}
            selectedExtensions={selectedExtensions}
            onExportAvailabilityChange={setCanExport}
            onAvailableExtensionsChange={setAvailableExtensions}
            onExtensionNameMapChange={setExtensionNameMap}
          />
        ) : (
          <Flex justifyContent="center" alignItems="center" height="100%">
            <Text>{t('dateTimeRange.selectDateRange')}</Text>
          </Flex>
        )}
      </Flex>
    </ReportingI18nProvider>
  )
}
